import { render } from "./PurchaseList.vue?vue&type=template&id=67cb9d1a&scoped=true"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"

import "./PurchaseList.vue?vue&type=style&index=0&id=67cb9d1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cb9d1a"]])

export default __exports__